import { render, staticRenderFns } from "./chooseSetmeal.vue?vue&type=template&id=39717ce9&"
import script from "./chooseSetmeal.vue?vue&type=script&lang=js&"
export * from "./chooseSetmeal.vue?vue&type=script&lang=js&"
import style0 from "./chooseSetmeal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports